import {
  FaClipboardList,
  FaCalendarCheck,
  FaTimesCircle,
  FaCheckCircle,
} from "react-icons/fa";

const OrderingStats = ({ stats, onDeleteAll }) => {
  return (
    <div className="bg-dry py-3 rounded-md">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        {/* Total Bookings */}
        <div className="flex items-center gap-4 border border-white/20 p-4 rounded-md">
          <div className="bg-redlight rounded-full p-2">
            <FaClipboardList className="text-border w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-white/70">Total Bookings</p>
            <p className="text-lg font-bold text-white">{stats.total}</p>
          </div>
        </div>

        {/* Upcoming Bookings */}
        <div className="flex items-center gap-4 border border-white/20 p-4 rounded-md">
          <div className="bg-green-100 rounded-full p-2">
            <FaCalendarCheck className="text-green-700 w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-white/70">Upcoming Bookings</p>
            <p className="text-lg font-bold text-white">{stats.upcoming}</p>
          </div>
        </div>

        {/* Cancelled Bookings */}
        <div className="flex items-center gap-4 border border-white/20 p-4 rounded-md">
          <div className="bg-red-100 rounded-full p-2">
            <FaTimesCircle className="text-red-700 w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-white/70">Cancelled Bookings</p>
            <p className="text-lg font-bold text-white">{stats.cancelled}</p>
          </div>
        </div>

        {/* Completed Bookings */}
        <div className="flex items-center gap-4 border border-white/20 p-4 rounded-md">
          <div className="bg-gray-400 rounded-full p-2">
            <FaCheckCircle className="text-white w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-white/70">Completed Bookings</p>
            <p className="text-lg font-bold text-white">{stats.completed}</p>
          </div>
        </div>
      </div>

      {/* Delete All Button */}
      <div className="flex justify-end">
        <button
          onClick={onDeleteAll}
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 text-sm font-semibold"
        >
          Delete All
        </button>
      </div>
    </div>
  );
};

export default OrderingStats;
